import styled from "styled-components";
import { getHexOpacity } from "../../../../../utils/pipes";

export const ToolbarContentManagement = styled.div`
  .toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    border: 1px solid #FFFFFF;
    border-radius: 20px;
    height: 56px;
    box-sizing: border-box;
    &__left {
      align-items: center;
      display: flex;
      .buttons-separator {
        height: 14px;
        border-left: 1px solid var(--Backgrounds-Separador-II, #FFFFFF);
        margin: 0 10px;
      }
    }
    &__right {
      .searcher-container {
        width: 429px;
      }
    } 
  }
`;